import styled from 'styled-components'

export const Root = styled.div``

export const Dl = styled.dl``

export const Dt = styled.dt`
  float: left;
  margin-right: 5px;
`

export const Dd = styled.dd`
  font-weight: bold;
`
